import React, { useState } from 'react';
import { t } from '../translations';

// Rensar bort Markdown-formatering så att delningstexten blir ren och snygg
function extractSummarySnippet(markdownText, maxLength = 260) {
  if (!markdownText) return '';
  const clean = markdownText
    .replace(/^#+\s+/gm, '')
    .replace(/\*\*/g, '')
    .replace(/[-*]\s+/g, '')
    .trim();

  const firstParagraph = clean.split('\n\n')[0] || clean;
  if (firstParagraph.length <= maxLength) return firstParagraph;
  return firstParagraph.substring(0, maxLength).trim() + '...';
}

export default function ShareButton({ title, summary, url, language, className = '' }) {
  const [feedback, setFeedback] = useState(null);

  const handleShare = async (e) => {
    e.stopPropagation(); // Hindrar att klicket råkar expandera eller fälla ihop artikelkortet

    const snippet = extractSummarySnippet(summary);
    const shareUrl = url || 'https://sciencemonitor.se';
    const footer = t(language, 'share_footer');
    const textContent = `🔬 ${title}\n\n${snippet}\n\n${footer}`;

    const sharePayload = {
      title: `🔬 ${title}`,
      text: textContent,
      url: shareUrl,
    };

    // 1. Testa telefonens inbyggda delningsmeny (Web Share API)
    if (typeof navigator !== 'undefined' && navigator.share && navigator.canShare && navigator.canShare(sharePayload)) {
      try {
        await navigator.share(sharePayload);
        setFeedback('success');
        setTimeout(() => setFeedback(null), 2500);
        return;
      } catch (err) {
        if (err.name === 'AbortError') return; // Användaren klickade bara ner rutan
        console.warn('Native share misslyckades, testar urklipp istället:', err);
      }
    }

    // 2. Fallback för dator: Kopiera formaterad text + länk till urklipp
    const clipboardText = `🔬 ${title}\n\n${snippet}\n\n${footer} ${shareUrl}`;

    if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(clipboardText);
        setFeedback('copied');
        setTimeout(() => setFeedback(null), 2500);
      } catch (err) {
        console.error('Kunde inte skriva till urklipp:', err);
      }
    }
  };

  return (
    <button
      onClick={handleShare}
      type="button"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-lg transition-all duration-150 border ${
        feedback
          ? 'bg-emerald-50 text-emerald-700 border-emerald-300 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800'
          : 'bg-white text-slate-700 border-slate-200 hover:bg-slate-50 hover:text-slate-900 dark:bg-slate-800 dark:text-slate-200 dark:border-slate-700 dark:hover:bg-slate-700'
      } ${className}`}
      title={t(language, 'share_title')}
      aria-label={t(language, 'share_title')}
    >
      {feedback ? (
        <>
          <svg className="w-3.5 h-3.5 text-emerald-600 dark:text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
          </svg>
          <span>{t(language, feedback === 'copied' ? 'share_copied' : 'share_success')}</span>
        </>
      ) : (
        <>
          <svg className="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
          </svg>
          <span>{t(language, 'share_btn')}</span>
        </>
      )}
    </button>
  );
}